import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import { Color } from '@/constants/color';
import Button from '@/ui/components/Button';

import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Modal = ({
  backgroundColor = 'dark:bg-uniform-gray-800 light:bg-uniform-gray-50',
  blurredBackground = false,
  buttonAriaLabel,
  buttonContent,
  buttonSize,
  buttonTitle,
  dismissButton = false,
  leadingImage,
  onClose,
  open,
  restrictCloseToButton = false,
  textContent,
  title
}: Props) => {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-30 font-roboto"
        onClose={() => {
          if (!restrictCloseToButton) onClose();
        }}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div
            className={`fixed inset-0 ${backgroundColor} bg-opacity-60 transition-opacity${
              blurredBackground ? ' backdrop-blur-xs' : ''
            }`}
          />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-hidden">
          <div className="flex min-h-full justify-center p-4 text-center items-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel className="relative transform overflow-y-auto rounded-lg dark:bg-uniform-gray-900 dark:text-uniform-gray-200 light:bg-uniform-gray-50 light:text-uniform-gray-800 px-6 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 max-h-[calc(100vh-2rem)]">
                <div>
                  {!!leadingImage && (
                    <img
                      className="mx-auto h-40 flex items-center justify-center"
                      src={leadingImage}
                      alt=""
                    />
                  )}
                  <div className="mt-3 text-center sm:mt-5">
                    {!!title && (
                      <Dialog.Title
                        as="h3"
                        className="text-3xl font-bold dark:text-uniform-white-base light:text-uniform-gray-900">
                        {title}
                      </Dialog.Title>
                    )}
                    <div className="mt-2 ">
                      {!!textContent &&
                        (typeof textContent === 'string' ? (
                          <p className="dark:text-gray-200">{textContent}</p>
                        ) : (
                          textContent
                        ))}
                    </div>
                  </div>
                </div>
                <div className={`mt-5 ${dismissButton ? 'flex space-x-2' : ''}`}>
                  {dismissButton && (
                    <Button
                      ariaLabel={dismissButton.buttonAriaLabel}
                      className="shrink"
                      color={dismissButton.buttonColor || Color.GRAY}
                      size={buttonSize}
                      title={dismissButton.buttonTitle}
                      onClick={onClose}>
                      {dismissButton.buttonContent}
                    </Button>
                  )}
                  <Button
                    ariaLabel={buttonAriaLabel}
                    className="grow"
                    color={Color.GREEN}
                    disabled={dismissButton ? dismissButton.mainButtonDisabled : false}
                    size={buttonSize}
                    title={buttonTitle}
                    onClick={dismissButton ? dismissButton.mainButtonAction : onClose}>
                    {buttonContent}
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
